import { Link } from "react-router-dom";
import { en } from "../../i18n/en";

const t = en.privacy;

/** Public, since Google's consent screen links to it (specs/11 FR-78, specs/12 FR-83). */
export function PrivacyScreen() {
  return (
    <main className="mx-auto max-w-2xl px-4 py-8">
      <Link to="/" className="text-sm text-sky-400 underline">
        {en.appName}
      </Link>
      <h1 className="mt-4 text-2xl font-semibold">{t.title}</h1>
      <p className="mb-6 text-sm text-slate-400">{t.updated}</p>
      {t.sections.map((section) => (
        <section key={section.heading} className="mb-5">
          <h2 className="mb-1 text-lg font-semibold">{section.heading}</h2>
          <p className="text-slate-300">{section.body}</p>
        </section>
      ))}
      <p className="mt-8 text-xs text-slate-400">{en.disclaimer}</p>
    </main>
  );
}
